import { render } from "./PopupWrapper.vue?vue&type=template&id=2e2d344a&ts=true"
import script from "./PopupWrapper.vue?vue&type=script&lang=ts"
export * from "./PopupWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__